import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    setIsMenuOpen(false);
  };

  return (
    <div
      className={`
        fixed top-2 z-50 
        mx-4 
        w-[calc(100%-2rem)] 
        flex md:flex-row flex-col
        justify-between items-center
        px-6 md:px-10
        py-5
        text-xl text-white
        transition-all duration-300
        ${
          scrolled
            ? "bg-gray-800/70 backdrop-blur-md rounded-full border border-white/20"
            : "bg-transparent"
        }
      `}
    >
      {/* Logo LEFT */}
      <div className="flex items-center h-full">
        <p className="text-3xl font-semibold hover:text-green-400">
          &lt;/KM&gt;
        </p>

        <button
          className="text-2xl md:hidden ml-4"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Menu RIGHT */}
      <ul
        className={`${isMenuOpen ? "flex" : "hidden"} 
          md:flex flex-row
          items-center
          gap-6 md:gap-8
          text-xl md:text-2xl font-semibold`}
      >
        {["home", "about", "skills", "projects", "contact"].map((item) => (
          <li key={item} className="cursor-pointer hover:text-green-400">
            <button onClick={() => scrollToSection(item)}>
              {item.charAt(0).toUpperCase() + item.slice(1)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Header;
